<template>
  <div class="home-InfoPanel">
    <h3 class="panel-title">{{title}}</h3>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="less" scoped>
.home-InfoPanel {
    .panel-title{
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: rgba(51,51,51,0.85);
        font-weight: 500;
        padding: 10px 0;
        &::before{
            content: ' ';
            width: 2px;
            height: 10px;
            background: #00A497;
            float: left;
            margin-top: 6px;
            margin-left: 4px;
            margin-right: 4px;
        }
    }
}
</style>
